import { render, staticRenderFns } from "./processed-tab.vue?vue&type=template&id=492c7d7d&"
import script from "./processed-tab.vue?vue&type=script&lang=js&"
export * from "./processed-tab.vue?vue&type=script&lang=js&"
import style0 from "./processed-tab.vue?vue&type=style&index=0&id=492c7d7d&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports